import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://backendapi.vinautochecker.com";
// console.log(process.env.REACT_APP_API_BASE_URL);
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const blogService = {
  // Auth
  login: (data) => api.post("/login", data),
  register: (data) => api.post("/register", data),
  logout: () => api.post("/logout"),
  getUser: () => api.get("/user"),
  verifyEmail: (token) => api.get(`/email/verify/${token}`),

  // Posts
  getAllPosts: (params) => api.get("/posts", { params }),
  getUserPosts: () => api.get("/user/posts"),
  createPost: (data) => api.post("/posts", data),
  updatePost: (id, data) => api.put(`/posts/${id}`, data),
  getPost: (id) => api.get(`/posts/${id}`),
  deletePost: (id) => api.delete(`/posts/${id}`),

  // Profile
  updateProfile: (formData) =>
    api.post("/profile/update", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  changePassword: (data) => api.post("/profile/change-password", data),

  // AI
  generateAIContent: (title) => api.post("/generate-content", { title }),

  // Upload
  uploadImage: (formData) =>
    api.post("/upload-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
};

export default api;
